// extracted by mini-css-extract-plugin
export var main = "About-module--main--3AZVK";
export var content = "About-module--content--36v59";
export var circle = "About-module--circle--3pZQg";
export var circleOne = "About-module--circle-one--1otrk";
export var circleTwo = "About-module--circle-two--3WEB4";